import bus from '@/utils/request/bus'
import { encrypt } from '@/utils/jsencrypt'

// 获取用户列表
export function listUser(query) {
  return bus({
    url: '/ecenter/system/user/list',
    method: 'get',
    params: query,
    headers: {
      'System-Sign': 'gemini3'
    }
  })
}

// 获取用户树
export function listDept(query) {
  return bus({
    url: '/ecenter/system/dept/list',
    method: 'get',
    params: query,
    headers: {
      'System-Sign': 'gemini3'
    }
  })
}

// 用户密码重置
export function resetUserPwd(userId, password) {
  password = encrypt(password)
  const data = {
    userId,
    password
  }
  return bus({
    url: '/ecenter/system/user/resetPwd',
    method: 'put',
    data: data,
    headers: {
      'System-Sign': 'gemini3'
    }
  })
}

// 新增用户
export function addUser(data) {
  return bus({
    url: '/ecenter/system/user',
    method: 'post',
    data: data,
    headers: {
      'System-Sign': 'gemini3'
    }
  })
}

// 用户详情
export function getItem(userId) {
  return bus({
    url: `/ecenter/system/user/${userId}`,
    method: 'get',
    headers: {
      'System-Sign': 'gemini3'
    }
  })
}

// 更新用户
export function updateUser(data) {
  return bus({
    url: '/ecenter/system/user',
    method: 'put',
    data: data,
    headers: {
      'System-Sign': 'gemini3'
    }
  })
}

// 角色列表（按系统分组）
export function listChannelRole() {
  return bus({
    url: '/ecenter/system/channel/role/list',
    method: 'get',
  })
}

/**
 * 列表转树
 * @param {Array} list 原始列表
 * @param {String} key 主键名称
 * @param {String} parentKey 父级节点主键名称
 * @returns
 */
export function list2tree(list, key = 'deptId', parentKey = 'parentId') {
  let rootList = []
  const nodeIds = new Set(list.map(item => item[key]))

  list.forEach(item => {

    item.value = item[key]
    item.label = item['deptName']

    if (item[parentKey] == 0 || !nodeIds.has(item[parentKey])) {
      item._open = true
      rootList.push(item)
    }
  })

  const insertBranch = (item) => {
    let branch = list.filter(a => a[parentKey] == item[key])
    if (branch.length > 0) {
      item.children = branch
      branch.forEach(b => {
        insertBranch(b)
      })
    }
  }

  rootList.forEach(item => {
    insertBranch(item)
  })


  return rootList
}